import { jsx as _jsx } from "react/jsx-runtime";
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createRuntime, loginRequestB2B, loginRequestB2C, msalInstance } from '.';
import { AuthenticationBoundary, UserContextProvider } from '..';
import { AuthorizationProvider } from '../..';
import { registerRemoteModules } from '../../loader';
import { ApplicationInsightsLogger, RuntimeContext, getAppInsights, initializeApplicationInsights, registerStaticModules, } from '../../shell';
import { Shell } from '../types';
async function registerDynamicRemotes(remotes, runtime) {
    const registerResult = await registerRemoteModules(remotes ?? [], runtime);
    if (registerResult.remotesForRetry.length > 0) {
        runtime.setFailedToFetchRemotes(registerResult.remotesForRetry);
    }
}
async function registerStaticRemotes(register, runtime) {
    await registerStaticModules([register], runtime);
}
async function runRegisters(remotes, register, runtime) {
    await registerStaticRemotes(register, runtime);
    await registerDynamicRemotes(remotes, runtime);
}
function render(children, remotes, register, shell = Shell.Business, runtime, hasAuthentication = true) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(React.StrictMode, { children: _jsx(RuntimeContext.Provider, { value: runtime, children: _jsx(AuthorizationProvider, { children: _jsx(UserContextProvider, { children: shell === Shell.Business && hasAuthentication ? (_jsx(AuthenticationBoundary, { children: children })) : (_jsx(MsalProvider, { instance: msalInstance, children: children })) }) }) }) }));
}
async function initialize(shell, register, remotes, loggers) {
    const runtime = createRuntime({ shell, loggers });
    runtime.setAllRemotes(remotes);
    initializeApplicationInsights(shell, remotes);
    runtime.logger.addLogger(new ApplicationInsightsLogger());
    // handle auth redired/do all initial setup for msal
    await msalInstance
        .handleRedirectPromise()
        .then(async (_) => {
        // Check if user signed in
        const account = msalInstance.getActiveAccount();
        if (!account) {
            shell == Shell.Business
                ? msalInstance.loginRedirect({
                    ...loginRequestB2B(),
                })
                : msalInstance.loginRedirect({
                    ...loginRequestB2C,
                });
        }
        else {
            runRegisters(remotes, register, runtime);
            const account = msalInstance?.getActiveAccount();
            if (account) {
                getAppInsights().getValue().setAuthenticatedUserContext(account.username, account.localAccountId, true);
            }
        }
    })
        .catch(err => {
        // TODO: Handle errors
        console.log(err);
    });
    return runtime;
}
export async function renderRoot({ children, remotes, register, shell = Shell.Business, hasAuthentication = true, loggers = null, }) {
    const runtime = await initialize(shell, register, remotes, loggers);
    render(children, remotes, register, shell, runtime, hasAuthentication);
}
